import { moneyFormat } from '@4beefopag/4bee-fopag-core/dist/util';
import { Col, Row } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { MODULE_BENEFIT_ORDER } from '../../../constants/modules';
import { BENEFIT_ORDER } from '../../../services/util/globalConstant';
import LabelValue from '../../atoms/LabelValue';
import SelectFolha from '../../atoms/SelectFolha';
import BenefitOrderReopeningStatusTooltip from '../../molecules/BenefitOrderReopeningStatusTooltip';

const LabelValueWrap = styled.div`
  background: white;
  padding: 5px 10px;
`;

const RowMargin = styled(Row)`
  margin-top: 42px;
`;

export default function OrderBenefitSummary({
  companyId,
  onChangeFolha,
  loading,
  benefitOrder,
  disableCompanySelect,
  hideInfoCards,
}) {
  const defaultValue = (value) => {
    if (!benefitOrder || !value) return '---';
    return value;
  };
  return (
    <>
      <Row
        type="flex"
        gutter={[16, 16]}
      >
        <Col
          xs={24}
          sm={24}
          md={16}
          lg={16}
          xl={16}
        >
          <SelectFolha
            module={MODULE_BENEFIT_ORDER}
            idFolhaSelecionada={companyId}
            onChange={onChangeFolha}
            shouldAutoSelectSingleCompany
            disabled={disableCompanySelect}
          />
        </Col>
      </Row>
      {!hideInfoCards && (
        <RowMargin
          type="flex"
          gutter={[16, 16]}
        >
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={4}
            xl={4}
          >
            <LabelValueWrap>
              <LabelValue
                label="Competência"
                value={defaultValue(benefitOrder && benefitOrder.competence.format('MM/YYYY'))}
                fontSizeValue="20px"
                fontSizeLabel="10px"
                loading={loading}
              />
            </LabelValueWrap>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={4}
            xl={4}
          >
            <LabelValueWrap>
              <LabelValue
                label="Período pra Lançamentos"
                value={defaultValue(
                  benefitOrder && `${benefitOrder.startDate.format('DD/MM')} a ${benefitOrder.endDate.format('DD/MM')}`
                )}
                fontSizeValue="20px"
                fontSizeLabel="10px"
                loading={loading}
              />
            </LabelValueWrap>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={4}
            xl={4}
          >
            <LabelValueWrap>
              <LabelValue
                label="Valor VA Total"
                value={defaultValue(benefitOrder && moneyFormat(benefitOrder.totalFoodVoucher))}
                fontSizeValue="20px"
                fontSizeLabel="10px"
                loading={loading}
              />
            </LabelValueWrap>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={4}
            xl={4}
          >
            <LabelValueWrap>
              <LabelValue
                label="Valor VR Total"
                value={defaultValue(benefitOrder && moneyFormat(benefitOrder.totalMealVoucher))}
                fontSizeValue="20px"
                fontSizeLabel="10px"
                loading={loading}
              />
            </LabelValueWrap>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={4}
            xl={4}
          >
            <LabelValueWrap>
              <LabelValue
                label="Pedido"
                value={defaultValue(benefitOrder && benefitOrder.statusDescription)}
                fontSizeValue="20px"
                fontSizeLabel="10px"
                loading={loading}
              />
            </LabelValueWrap>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={4}
            xl={4}
          >
            <BenefitOrderReopeningStatusTooltip benefitOrder={benefitOrder}>
              <LabelValueWrap>
                <LabelValue
                  label="Reabertura"
                  value={defaultValue(benefitOrder && benefitOrder.reopeningStatusDescription)}
                  valueColor={BENEFIT_ORDER.reopeningStatusColorMap[benefitOrder && benefitOrder.reopeningStatus]}
                  fontSizeValue="20px"
                  fontSizeLabel="10px"
                  loading={loading}
                />
              </LabelValueWrap>
            </BenefitOrderReopeningStatusTooltip>
          </Col>
        </RowMargin>
      )}
    </>
  );
}

OrderBenefitSummary.propTypes = {
  companyId: PropTypes.number.isRequired,
  disableCompanySelect: PropTypes.number.isRequired,
  onChangeFolha: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  hideInfoCards: PropTypes.bool,
  benefitOrder: PropTypes.shape,
};

OrderBenefitSummary.defaultProps = {
  loading: false,
  hideInfoCards: false,
  benefitOrder: undefined,
};
